import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { isCapacitorNative } from '../platform/capacitor-platform';

/**
 * Guard for user-only routes (e.g. Dashboard).
 * Redirects admins to /admin so they never see the Dashboard (web only).
 */
@Injectable({
  providedIn: 'root'
})
export class NonAdminGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    const user = this.authService.getUser();
    if (user?.admin && !isCapacitorNative()) {
      this.router.navigate(['/admin']);
      return false;
    }
    return true;
  }
}
